var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as _ from "lodash";
import { DiagramBase } from '../basics/DiagramBase';
import { prepareDiagramDataHierarchical } from '../basics/Statistics';
import { setIfDef, setOrDef } from "../Helpers";
var rot = function (c) {
    switch (c) {
        case "Angle0":
            return 0;
        case "Angle15":
            return 15;
        case "Angle30":
            return 30;
        case "Angle45":
            return 45;
        default:
            return c.toLocaleLowerCase();
    }
};
var Sunburst = /** @class */ (function (_super) {
    __extends(Sunburst, _super);
    function Sunburst() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.calcData = function (props) {
            if (props.diagram.rawData) {
                _this.setState({
                    data: props.diagram.url
                });
            }
            else {
                prepareDiagramDataHierarchical(props.diagram).then(function (data) {
                    //console.log(data);
                    _this.setState({ data: data.data });
                    if (_this.props.onFieldsLoaded)
                        _this.props.onFieldsLoaded(data.fields);
                });
            }
        };
        _this.findDataElement = function (path) {
            return _this.findInHierarchy(0, path, _this.state.data);
        };
        _this.getClickPath = function (data) {
            var path = {};
            for (var i = 1; i < data.treePathInfo.length; i++)
                path[_this.props.diagram.groupBy[i - 1]] = data.treePathInfo[i].name;
            return path;
        };
        _this.getOption = function () {
            var d = _this.props.diagram;
            if (!_this.state.data)
                return undefined;
            var min = 0;
            var mby = _.maxBy(_this.state.data, function (d) { return d.aggregation; });
            var max = mby ? mby.aggregation : 0.0;
            var colors = _this.props.diagram.colors;
            var vmap = {};
            if (colors && min !== undefined && max !== undefined) {
                var splitNumber = colors.colors.length;
                vmap = {
                    min: min,
                    max: Math.ceil(max / splitNumber) * splitNumber,
                    splitNumber: splitNumber,
                };
            }
            var option = {
                color: _this.props.diagram.colors ? _this.props.diagram.colors.colors : undefined,
                backgroundColor: _this.props.diagram.backgroundColor,
                tooltip: {},
                toolbox: {
                    bottom: -5,
                    right: 0,
                    showTitle: false,
                    orient: 'horizontal',
                    feature: {
                        saveAsImage: {
                            show: d.legend && d.legend.showDownload ? d.legend.showDownload : false,
                            type: 'png'
                        }
                    }
                },
                visualMap: d.showVisMap ? __assign(__assign({ show: true, type: setOrDef(d, function (x) { return d.mapType; }, 'continuous'), calculable: setOrDef(d, function (x) { return x.visMapCalculable; }, false) }, vmap), { orient: setOrDef(d, function (x) { return x.orientation; }, 'horizontal'), inRange: _this.props.diagram.colors ? {
                        color: _this.props.diagram.colors.colors
                    } : undefined, color: setOrDef(d, function (x) { return x.visMapColor; }, '#000000') }) : undefined,
                series: {
                    startAngle: setOrDef(d, function (x) { return x.startAngle; }, 90),
                    nodeClick: d.enableSpecificStyling === true ? false : 'rootToNode',
                    type: 'sunburst',
                    highlightPolicy: 'descendant',
                    data: _this.state.data,
                    radius: [
                        setOrDef(d, function (x) { return x.innerRadius; }, 10) + "%",
                        setOrDef(d, function (x) { return x.outerRadius; }, 85) + "%",
                    ],
                    sort: d.sortOrder ? (d.sortOrder !== "None" ? d.sortOrder.toLowerCase() : null) : null,
                    label: d.label ? {
                        show: d.label.show === true ? true : false,
                        rotate: rot(setOrDef(d.label, function (x) { return x.orientation; }, 'Radial')),
                        position: setOrDef(d.label, function (x) { return x.position; }, "inside"),
                        color: setOrDef(d.label, function (x) { return x.color; }, '#000000'),
                        distance: setOrDef(d.label, function (x) { return x.distance; }, 5),
                        fontSize: setOrDef(d.label, function (x) { return x.fontSize; }, 12),
                        formatter: setIfDef(d.label, function (x) { return _this.getLabelFormatter(x); })
                    } : undefined,
                    /*                levels: !this.props.diagram.sunburstShowVisMap && this.props.diagram.colors ? [{}, ...this.props.diagram.colors.colors.map(c => ({
                                        itemStyle: { color: c }
                                    }))] : undefined
                                    */
                    levels: d.enableSpecificStyling && d.ringStyles ? __spreadArrays([{}], _.map(d.ringStyles, function (s, i) { return ({
                        r0: s.innerRadius ? s.innerRadius + "%" : undefined,
                        r: s.outerRadius ? s.outerRadius + "%" : undefined,
                        itemStyle: {
                            color: s.color,
                        },
                        label: s.label ? {
                            show: s.label.show === true ? true : false,
                            rotate: rot(setOrDef(s.label, function (x) { return x.orientation; }, "Angle0")),
                            position: setOrDef(s.label, function (x) { return x.position; }, "inside"),
                            color: setOrDef(s.label, function (x) { return x.color; }, "#000"),
                            fontSize: setOrDef(s.label, function (x) { return x.fontSize; }, 12),
                            distance: setOrDef(s.label, function (x) { return x.distance; }, 0),
                            formatter: setIfDef(s.label, function (x) { return x.formatter; })
                        } : undefined,
                    }); })) : undefined,
                }
            };
            console.log(option);
            return option;
        };
        _this.findInHierarchy = function (keyPos, path, element) {
            //console.log("---");
            //console.log(keyPos);
            //console.log(path);
            if (keyPos >= _this.props.diagram.groupBy.length)
                return undefined;
            var idx = _.findIndex(element, function (e) { return e.name === path[_this.props.diagram.groupBy[keyPos]]; });
            if (idx < 0)
                return undefined;
            if (Object.keys(path).length - 1 === keyPos) {
                //console.log("found it!");
                //console.log(element[idx]);
                return [element[idx]];
            }
            return _this.findInHierarchy(keyPos + 1, path, element[idx].children);
        };
        return _this;
    }
    return Sunburst;
}(DiagramBase));
export default Sunburst;
//export default connect(state => ({ state }))(Sunburst);
//# sourceMappingURL=Sunburst.js.map